import React, { useContext } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import LoginContext from './LoginContext'

export default function EnsureLogin ({ children }) {
  const { user } = useContext(LoginContext)

  if (!user) {
    return <></>
  }
  if (user.isAuth) {
    return children || <Outlet />
  } else {
    return (
      <Navigate to='/admin/login' replace={true} />
    )
  }
}
